import { AuthWrapper } from '../Wrapper';

export function AuthLoading() {
  return (
    <AuthWrapper>
      <div>
        <div className='flex flex-col mb-4 space-y-6 mt-12 animate-pulse'>
          <div className='w-full h-9 bg-white/20 rounded-lg' />
          <div className='w-full h-9 bg-white/20 rounded-lg' />
        </div>
        <div className='flex items-center justify-between mb-4 mt-8 animate-pulse'>
          <div className='w-32 h-9 bg-white/20 rounded-lg' />
          <div className='w-32 h-9 bg-white/20 rounded-lg' />
        </div>
        <div className='flex flex-col mb-4 space-y-4 mt-12 animate-pulse'>
          <div className='w-10/12 h-6 bg-white/20 rounded-lg' />
          <div className='w-8/12 h-6 bg-white/20 rounded-lg' />
        </div>
      </div>
    </AuthWrapper>
  );
}
